import React from 'react';
import {
  Box, Grid, Tooltip,

} from '@material-ui/core';
import InfoCard, { InfoCardTemplate } from 'components/InfoCard';
import { ReactComponent as CoinGraph } from 'assets/icons/coin-graph.svg';
import { ReactComponent as ReturnPercentage } from 'assets/icons/project-return-money-green.svg';
import { ReactComponent as MoneyHands } from 'assets/icons/money-hands-currentColor.svg';
import { ReactComponent as Loan } from 'assets/icons/project-hand-money-green.svg';
import { ReactComponent as Frequency } from 'assets/icons/certification-green.svg';
import { ReactComponent as Money } from 'assets/icons/project-money-green.svg';
import { ReactComponent as ProjectTime } from 'assets/icons/project-time-green.svg';
import { ReactComponent as ProjectPay } from 'assets/icons/project-pay-green.svg';
import { ReactComponent as Time } from 'assets/icons/project-watch-money-green.svg';
import { ReactComponent as Document } from 'assets/icons/document-money-green.svg';
import { colors } from 'globalStyle';
import { Title, Text, Bold } from 'components/Texts';
import { formatNumber } from 'util/formatNumber';
import { routes } from 'routes';
import { Link } from 'wouter';
import {
  typesProjectType,
  colorByProjectType,
} from 'types/projectType';
import { idProjectEnergiaSolar } from 'types/idProject';
import { calculatePercentage } from 'util/percent';
import { payFrequency } from 'types/payFrecuency';
import { useMediaQuery } from 'hooks';

const idProjectNatureCore = '46c68022-7403-4bc1-a3ab-44046e4f9890';

export default function LoanConditions({
  ieaTax,
  maxAmount,
  returnTime,
  frequency,
  isWarranty,
  warranty,
  gracePeriod,
  warrantyCompanyId,
  warrantyCompanyName,
  frequencyInterest,
  currencyIso,
  projectType,
  graceType,
  id,
  styles,
  resourcesGathering,
  color,
}) {
  const isDesktop = useMediaQuery(1023);
  const gracePeriodProps = Object.freeze({
    NO_GRACE_PERIOD: {
      name: 'Sin período de gracia',
      description: 'No tiene período de gracia.',
    },
    ZERO_GRACE: {
      name: 'Cero',
      description:
        'Durante el período de gracia no recibes ni interés ni capital y el valor del interés se difiere en las cuotas de pago.',
    },
    INTEREST: {
      name: 'Interés',
      description:
        'Durante el período de gracia empiezas a recibir pago de interés sin capital.',
    },
    ACCUMULATED: {
      name: 'Acumulado',
      description:
        'Después del período de gracia recibes en la primera cuota todo el interés y parte del capital.',
    },
  });
  return (
    <Grid container spacing={isDesktop && 2} className={styles.root}>
      <Grid item xs={isDesktop && 4}>
        <InfoCard
          isDesktop={isDesktop}
          image={<ReturnPercentage color={color || colorByProjectType[projectType]} />}
          className={styles.primaryCard}
          color={colors.GRAY_10}
          title={`Recibe el ${calculatePercentage(ieaTax)}%`}
          subtitle="% Tasa de retorno fija E.A."
          imageWidth={isDesktop ? '50px' : '30px'}
          description={(
            <>
              Es el porcentaje de rendimientos fijos que recibes sobre tu inversión inicial.
              <br />
              Por medio de
              <Bold>{' Valores de Deuda.'}</Bold>
            </>
          )}
          fullDescription
          centerDescription
        />
      </Grid>
      <Grid item xs={isDesktop && 4}>
        <InfoCard
          isDesktop={isDesktop}
          image={<Money color={color || colorByProjectType[projectType]} />}
          className={styles.primaryCard}
          color={colors.GRAY_10}
          title={formatNumber(maxAmount, null, currencyIso)}
          subtitle="Monto máximo"
          imageWidth={isDesktop ? '50px' : '30px'}
          description="La cantidad total de dinero que la empresa busca recaudar para financiar su proyecto."
          fullDescription
          centerDescription
        />
      </Grid>
      <Grid item xs={isDesktop && 4}>
        <InfoCard
          isDesktop={isDesktop}
          image={<Loan color={color || colorByProjectType[projectType]} />}
          className={styles.primaryCard}
          color={colors.GRAY_10}
          imageWidth={isDesktop ? '50px' : '30px'}
          title={`${returnTime} ${returnTime === 1 ? 'mes' : 'meses'}`}
          subtitle="Tiempo de financiación"
          description="El período de tiempo previsto para recuperar la inversión."
          fullDescription
          centerDescription
        />
      </Grid>
      <Grid item xs={isDesktop && 3}>
        <InfoCard
          fullDescription
          centerDescription
          isDesktop={isDesktop}
          image={<ProjectTime color={color || colorByProjectType[projectType]} />}
          color={colors.GRAY_10}
          hoverDescription={isDesktop}
          subtitle="Recolección de recursos"
          imageWidth={isDesktop ? '50px' : '30px'}
          className={isDesktop ? styles.secondaryCard : styles.primaryCard}
          title={resourcesGathering}
          description="Tiempo durante el cual se planea hacer la recolección de los recursos para la financiación."
          colorByProjectType={color || colorByProjectType[projectType]}
        />
      </Grid>

      <Grid item xs={isDesktop && 3}>
        <InfoCard
          fullDescription
          centerDescription
          image={<Frequency color={color || colorByProjectType[projectType]} />}
          isDesktop={isDesktop}
          color={colors.GRAY_10}
          hoverDescription={isDesktop}
          colorByProjectType={color || colorByProjectType[projectType]}
          imageWidth={isDesktop ? '45px' : '28px'}
          isBigTitle={warrantyCompanyName?.length > 25}
          className={isDesktop ? styles.secondaryCard : styles.primaryCard}
          dynamicTitle
          title={(
            <>
              <Tooltip
                title={
                      !isDesktop
                      && (warranty ? ` ${warrantyCompanyName}` : 'Sin garantía')
                    }
                enterTouchDelay={0}
                leaveTouchDelay={5000}
              >
                <span>
                  {warranty ? ` ${warrantyCompanyName}` : 'Sin garantía'}
                </span>
              </Tooltip>
              <span
                style={{
                  display: isDesktop && 'flex',
                }}
              >
                {warranty ? ` ${(warranty * 100).toFixed()}%` : ''}
              </span>
            </>
              )}
          subtitle="Tipo de garantía"
          moreInfo={id === idProjectNatureCore && '(36 meses)'}
          description={(
            <>
              Nuestros proyectos podrán contar con un respaldo o garantía, la
              cual estará señalada en cada proyecto.
              {isWarranty && (
              <>
                <Grid container justify="flex-end">
                  <Link
                    href={`${routes.warranty.route}/${warrantyCompanyId}`}
                  >
                    <span
                      className={styles.anchor}
                      style={{ color: !isDesktop && colors.primary }}
                    >
                      Conoce la garantía
                    </span>
                  </Link>
                </Grid>
                <br />
              </>
              )}
            </>
              )}
        />
      </Grid>
      <Grid item xs={isDesktop && 3}>
        <InfoCard
          fullDescription
          centerDescription
          image={<Document color={color || colorByProjectType[projectType]} />}
          isDesktop={isDesktop}
          color={colors.GRAY_10}
          hoverDescription={isDesktop}
          colorByProjectType={color || colorByProjectType[projectType]}
          title={
                id === idProjectEnergiaSolar
                  ? 'Cuatrimestral'
                  : payFrequency[frequencyInterest]
              }
          imageWidth={isDesktop ? '45px' : '28px'}
          className={isDesktop ? styles.thirdCard : styles.primaryCard}
          subtitle={(
            <>
              Período de pago de
              {' '}
              <b>Rentabilidad Fija</b>
            </>
              )}
          description="Indica la periodicidad de pago de ganancias sobre la inversión realizada. (mensual, bimestral, trimestral, o semestral)"
        />
      </Grid>
      <Grid item xs={isDesktop && 3}>
        <InfoCard
          fullDescription
          centerDescription
          image={<Document color={color || colorByProjectType[projectType]} />}
          isDesktop={isDesktop}
          color={colors.GRAY_10}
          hoverDescription={isDesktop}
          colorByProjectType={color || colorByProjectType[projectType]}
          title={
                id === idProjectEnergiaSolar
                  ? 'Cuatrimestral'
                  : payFrequency[frequency]
              }
          imageWidth={isDesktop ? '45px' : '28px'}
          className={isDesktop ? styles.thirdCard : styles.primaryCard}
          subtitle={(
            <>
              Período de pago
              {' '}
              <b>capital</b>
            </>
              )}
          description="Corresponde al período de tiempo de retorno sobre la inversión realizada. (mensual, bimestral, trimestral, semestral o un solo pago)"
          moreInfo={frequency === 'BULLET' && 'Último periodo'}
        />
      </Grid>
      <Grid item xs={isDesktop && 3}>
        <InfoCard
          image={<Time color={color || colorByProjectType[projectType]} />}
          fullDescription
          centerDescription
          isDesktop={isDesktop}
          color={colors.GRAY_10}
          hoverDescription={isDesktop}
          colorByProjectType={color || colorByProjectType[projectType]}
          subtitle="Tiempo de período de gracia"
          imageWidth={isDesktop ? '50px' : '30px'}
          className={isDesktop ? styles.thirdCard : styles.primaryCard}
          title={`${gracePeriod} ${gracePeriod === 1 ? 'mes' : 'meses'}`}
          description="Tiempo en el cual no se realizan pagos al inicio del desarrollo del proyecto productivo, de igual forma, causan diferentes intereses correspondientes."
        />
      </Grid>
      <Grid item xs={isDesktop && 3}>
        <InfoCard
          fullDescription
          centerDescription
          image={<Time color={color || colorByProjectType[projectType]} />}
          isDesktop={isDesktop}
          color={colors.GRAY_10}
          hoverDescription={isDesktop}
          colorByProjectType={color || colorByProjectType[projectType]}
          subtitle="Tipo de período de gracia"
          imageWidth={isDesktop ? '50px' : '30px'}
          title={gracePeriodProps[graceType].name}
          description={
                isDesktop
                  ? 'Tiempo de periodo de gracia'
                  : gracePeriodProps[graceType].description
              }
          hoverTitleText={gracePeriodProps[graceType].name}
          className={isDesktop ? styles.thirdCard : styles.primaryCard}
          hoverDescriptionText={gracePeriodProps[graceType].description}
        />
      </Grid>
      <Grid item xs={isDesktop && 3}>
        <InfoCard
          fullDescription
          centerDescription
          image={<CoinGraph color={color || colorByProjectType[projectType]} />}
          isDesktop={isDesktop}
          color={colors.GRAY_10}
          hoverDescription={isDesktop}
          colorByProjectType={color || colorByProjectType[projectType]}
          subtitle="Cantidad disponible"
          imageWidth={isDesktop ? '50px' : '30px'}
          title="200"
          description="Hace referencia a la cantidad de Títulos Valor a ser Emitidos, este será el número máximo habilitado para que los usuarios realicen sus inversiones"
          hoverTitleText="Cantidad disponible"
          className={isDesktop ? styles.thirdCard : styles.primaryCard}
          hoverDescriptionText="Hace referencia a la cantidad de Títulos Valor a ser Emitidos, este será el número máximo habilitado para que los usuarios realicen sus inversiones"
        />
      </Grid>
      <Grid item xs={isDesktop && 3}>
        <InfoCard
          fullDescription
          centerDescription
          image={<MoneyHands color={color || colorByProjectType[projectType]} />}
          isDesktop={isDesktop}
          color={colors.GRAY_10}
          hoverDescription={isDesktop}
          colorByProjectType={color || colorByProjectType[projectType]}
          subtitle="Valor de cada Bono"
          imageWidth={isDesktop ? '60px' : '30px'}
          title="USD 50"
          description="El Valor de cada uno de los Bonos disponibles en la Emisión, este es a su vez el valor mínimo de inversión."
          hoverTitleText="Valor de cada Bono"
          className={isDesktop ? styles.thirdCard : styles.primaryCard}
          hoverDescriptionText="El Valor de cada uno de los Bonos disponibles en la Emisión, este es a su vez el valor mínimo de inversión."
        />
      </Grid>
      {!isDesktop && (
        <>
          <Grid item xs={isDesktop && 3}>
            <InfoCardTemplate className={styles.primaryCard}>
              <Grid
                container
                justify="center"
                direction="column"
                alignItems="center"
                style={{ height: '100%' }}
              >
                <Box width="45px">
                  <Time color={color || colorByProjectType[projectType]} />
                </Box>

                <Text size={12} isCenter mt={20} mb={20}>
                  Tipo de proyecto:
                </Text>

                <Title size={12} isCenter>
                  {typesProjectType[projectType]}
                </Title>

                <Text size={12} isCenter mt={20} mb={20}>
                  Tipo de Valor:
                </Text>

                <Title size={12} isCenter>
                  Bonos de Deuda
                </Title>
              </Grid>
            </InfoCardTemplate>
          </Grid>
          <Grid item xs={isDesktop && 3}>
            <InfoCardTemplate className={styles.primaryCard}>
              <Grid
                container
                justify="center"
                direction="column"
                alignItems="center"
                style={{ height: '100%' }}
              >
                <Box width="45px">
                  <ProjectPay color={color || colorByProjectType[projectType]} />
                </Box>
                <Title size={12} isCenter mt={30}>
                  Este proyecto permite el pre&#8209;pago total o parcial de la
                  deuda
                  <br />
                  <br />
                  Este proyecto no acepta recursos que superen su monto objetivo.
                </Title>
              </Grid>
            </InfoCardTemplate>
          </Grid>
        </>
      )}
    </Grid>
  );
}
